import React from 'react';
import ActionButton from '@/common/components/buttons/ActionButton';
import TextArea from '@/common/components/TextArea';
import Input from '@/common/components/Input';
import { Colors } from '@/common/colors/colors';
import {
	DetailSection,
	DetailTitle,
	ReviewActions,
} from '../../callAnalysis.styles';
import { getReviewModeLabel, REVIEW_MODE } from '../../helpers/labels';

const ReviewPanel = ({
	reviewMode,
	setReviewMode,
	correctedScore,
	setCorrectedScore,
	setComment,
	setFeedback,
	onReview,
	onReanalyze,
}) => {
	if (reviewMode) {
		return (
			<DetailSection>
				<DetailTitle>{getReviewModeLabel(reviewMode)}</DetailTitle>
				{reviewMode === REVIEW_MODE.CORRECTED && (
					<Input
						name='Score (0-100)'
						id='corrected_score'
						type='number'
						value={correctedScore}
						onChange={(e) => setCorrectedScore(e.target.value)}
						width={120}
						inputWidth={100}
						color={Colors.darkBlue}
					/>
				)}
				<TextArea
					placeholder='Team leader comment'
					width='100%'
					onChange={(e) => setComment(e.target.value)}
				/>
				<TextArea
					placeholder='Feedback to improve the AI system (optional)'
					width='100%'
					onChange={(e) => setFeedback(e.target.value)}
				/>
				<ReviewActions>
					<ActionButton
						defaultText='Cancel'
						color={Colors.newGray}
						onClick={() => setReviewMode(null)}
					/>
					<ActionButton
						defaultText='Save'
						color={Colors.darkBlue}
						onClick={() => onReview(reviewMode)}
					/>
				</ReviewActions>
			</DetailSection>
		);
	}

	return (
		<ReviewActions>
			<ActionButton
				defaultText='Re-analyze'
				color={Colors.purple}
				onClick={onReanalyze}
			/>
			<ActionButton
				defaultText='Accept'
				color={Colors.green}
				onClick={() => setReviewMode(REVIEW_MODE.ACCEPTED)}
			/>
			<ActionButton
				defaultText='Incorrect'
				color={Colors.red}
				onClick={() => setReviewMode(REVIEW_MODE.REJECTED)}
			/>
			<ActionButton
				defaultText='Correct'
				color={Colors.orange}
				onClick={() => setReviewMode(REVIEW_MODE.CORRECTED)}
			/>
		</ReviewActions>
	);
};

export default ReviewPanel;
